import axios from "axios";
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import { getHeader } from "../utilities/importantFns";
import { Doughnut } from "react-chartjs-2";
import { defaultUrl } from "../features/actions";
import React, { useEffect } from "react";

ChartJS.register(ArcElement, Tooltip, Legend);

export const ChartAttendance: React.FC = () => {
  const [summaryData, setSummaryData] = React.useState({
    absent: 0,
    birthdays: 0,
    students: 0,
    classrooms: 0,
    loggedin: 0,
    loggedout: 0,
    messages: 0,
    "non-teachers": 0,
    parent: 0,
    photosandvideos: 0,
    teachers: 0,
  });

  const fetchDashboardData = async () => {
    try {
      const data = await axios.get(`${defaultUrl}/user/dashboard`, getHeader());
      setSummaryData(data?.data?.data);
    } catch (err) {}
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const data = {
    labels: ["Logged In", "Logged Out", "Absent"],
    datasets: [
      {
        data: [
          summaryData?.loggedin || 0,
          summaryData?.loggedout || 0,
          summaryData?.absent || 0,
        ],
        backgroundColor: ["#0096D1", "#F59E0B", "#EF4444"],
        borderWidth: 3,
        borderColor: "#ffffff",
        hoverOffset: 4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#012063",
        padding: 12,
        cornerRadius: 12,
        titleFont: { size: 12, weight: "bold" as const },
        bodyFont: { size: 12 },
      },
    },
    cutout: "75%",
  };

  return (
    <div className="w-[140px] h-[140px] relative flex items-center justify-center">
      <Doughnut data={data} options={chartOptions} />
      <div className="absolute flex flex-col items-center justify-center pointer-events-none">
        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
          Total
        </span>
        <span className="text-lg font-black text-[#012063] font-mono leading-none mt-0.5">
          {(summaryData?.loggedin || 0) +
            (summaryData?.loggedout || 0) +
            (summaryData?.absent || 0)}
        </span>
      </div>
    </div>
  );
};
